var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('a',{staticClass:"advertise",attrs:{"href":_vm.link,"title":_vm.image.alt,"target":"_blank"},on:{"click":_vm.bannerClick}},[_c('img',{attrs:{"src":_vm.image.src,"alt":_vm.image.alt}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }